<mat-card  class="flex-col list-video-content list-video-card">
  <div class="flex-row list-video-card-title-wrapper">
    <div class="flex-col flex-justify-start flex-align-center video-card-image-container">
      <a
        routerLink="{{ content().permalink }}"
        class="flex-col flex-justify-center flex-align-center"
        >
        <img class="list-video-img" src="{{ content().pathFoto }}" />
      </a>
    </div>
    <div
      class="flex-col flex-justify-space-between flex-col-100 list-video-card-title-group-wrapper"
      >
      <mat-card-title-group>
        <mat-card-title class="list-video-title">
          <h2>
            @if (content().premium) {
              <img class="icona-premium" src="assets/premium.png" />
              }<a
              routerLink="{{ content().permalink }}"
              >
              {{ content().titolo }}</a
              >
            </h2>
          </mat-card-title>
          <mat-card-subtitle class="dottnet-card-subtitle">
            <a href="topic/{{ content().descrizioneTopic | urlClean }} "
              >{{ content().descrizioneTopic }} </a
              >| {{ content().autore }} |
              {{ content().dataCreazione | date : 'dd/MM/yyyy HH:mm' : 'UTC' }}</mat-card-subtitle
              >
            </mat-card-title-group>
          </div>
        </div>
        <div class="flex-row">
          <mat-card-content>
            <div class="flex-col dottnet-card-eyelet list-video-eyelet">
              <p>
                {{ isPreview() ? (content().descrizione | textPreview : 200) : content().descrizione }}
              </p>
            </div>
            @if (buttonAction()) {
              <a
                routerLink="{{ content().permalink }}"
                class="list-video-action"
                mat-raised-button
                color="accent"
                >
                {{ buttonAction() }}
              </a>
            }
          </mat-card-content>
        </div>
      </mat-card>
